import React, {Component} from 'react'
import Select from 'react-select'

export default class CategoriesSelectFormComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showSearchUserModal: false
    }
  }

  onUserSelected (user) {
    this.props.input.onChange(user)
    this.hideUserSearchModal()
  }

  render () {
    return (<div>
      <Select
        required={this.props.required}
        disabled={this.props.disabled}
        placeholder={this.props.placeholder}
        options={this.props.options}
        multi={this.props.multi}
        value={this.props.input.value}
        onChange={this.props.input.onChange} />
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/redux-form/CategoriesSelectFormComponent.js